export default "__VITE_ASSET__Czipw3Yr__"